class CartDrawer extends HTMLElement {
    constructor () {
        super();

        this.hasBeenOpened = false;

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility () {
        const cartLink = document.querySelector('#cart-icon-bubble');

        if (!cartLink) { return; }

        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            // Dont open if the user is on the cart page - DONOT REMOVE this will break the price reload
            if (window.pageTemplate != 'cart') {
                this.open(cartLink);
            }
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                // Dont open if the user is on the cart page - DONOT REMOVE this will break the price reload
                if (window.pageTemplate != 'cart') {
                    this.open(cartLink);
                }
            }
        });
    }

    open (triggeredBy) {
        if (triggeredBy) { this.setActiveElement(triggeredBy); }

        if (!this.hasBeenOpened && triggeredBy && triggeredBy.id === 'cart-icon-bubble') {
            this.hasBeenOpened = true;
            this.refreshCartContentAndOpen(triggeredBy);
            return;
        }

        this.hasBeenOpened = true;
        this.performOpen();
    }

    performOpen () {
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) { this.setSummaryAccessibility(cartDrawerNote); }
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');

            setTimeout(() => {
                this.initializeSliders();
            }, 150);
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

                trapFocus(containerToTrapFocusOn, focusElement);

                // Initialize sliders again after transition completes
                setTimeout(() => {
                    this.initializeSliders();
                }, 100);
            },
            { once: true },
        );

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        });

        document.body.classList.add('overflow-hidden');
    }

    close () {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility (cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents (parsedState) {
        // triggers when product is added to the basket - see product-form.js
        if (this.querySelector('.drawer__inner').classList.contains('is-empty')) {
            this.querySelector('.drawer__inner').classList.remove('is-empty');
        }

        this.productId = parsedState.id;

        this.getSectionsToRender().forEach((section) => {
            this.updateSection(section, parsedState);
        });

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();

            setTimeout(() => {
                this.initializeSliders();
                this.initializeRecommendations();
            }, 200);
        });
    }

    updateSection (section, parsedState) {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

        if (!sectionElement) {
            console.warn(`Section element not found: ${section.id}`);
            return;
        }

        const sectionData = parsedState.sections?.[section.section || section.id];

        if (!sectionData) {
            console.warn(`No section data for: ${section.id}`);
            return;
        }

        try {
            const newContent = this.getSectionInnerHTML(sectionData, section.selector);

            if (!newContent) { return; }

            sectionElement.innerHTML = newContent;

            if (section.id === 'cart-count-bubble') {
                this.updateCartCountBubble();
            }

            if (section.id === 'CartDrawer') {
                setTimeout(() => {
                    this.initializeSliders();
                    this.initializeRecommendations();
                }, 100);
            }
        } catch (e) {
            console.warn(`Error updating section ${section.id}:`, e);
        }
    }

    updateCartCountBubble () {
        const cartCountBubble = document.getElementById('cart-count-bubble');

        if (!cartCountBubble) { return; }

        const itemCount = cartCountBubble.querySelector('span[aria-hidden="true"]');
        const hasItems = itemCount && parseInt(itemCount.textContent) > 0;

        cartCountBubble.classList.toggle('hidden', !hasItems);
    }

    getSectionInnerHTML (html, selector = '.shopify-section') {
        if (!html) {
            return null;
        }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const element = parsed.querySelector(selector);

        return element ? element.innerHTML : null;
    }

    getSectionsToRender () {
        return [
            {
                id: 'cart-drawer',
                section: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-count-bubble',
                section: 'header',
                selector: '.cart-count-bubble',
            },
        ];
    }

    getSectionDOM (html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement (element) {
        this.activeElement = element;
    }

    refreshCartContentAndOpen (triggeredBy) {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const newCartDrawer = html.querySelector('#CartDrawer');
                const currentCartDrawer = document.querySelector('#CartDrawer');

                if (newCartDrawer && currentCartDrawer) {
                    currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

                    setTimeout(() => {
                        this.performOpen();
                    }, 50);
                } else {
                    this.performOpen();
                }
            })
            .catch((e) => {
                console.error('Error refreshing cart content:', e);
                this.performOpen();
            });
    }

    refreshCartContent () {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const newCartDrawer = html.querySelector('#CartDrawer');
                const currentCartDrawer = document.querySelector('#CartDrawer');

                if (newCartDrawer && currentCartDrawer) {
                    currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

                    setTimeout(() => {
                        this.initializeSliders();
                        this.initializeRecommendations();
                    }, 100);
                }
            })
            .catch((e) => {
                console.error('Error refreshing cart content:', e);
                this.initializeSliders();
            });
    }

    initializeSliders () {
        const sliders = this.querySelectorAll('slider-component');

        sliders.forEach((slider) => {
            if (!slider.swiper || !slider.swiper.initialized) {
                slider.dispatchEvent(new Event('slider:reinit'));
            } else if (slider.swiper) {
                slider.swiper.update();
                slider.swiper.updateSlides();
            }
        });
    }

    initializeRecommendations () {
        if (window.CartDrawerRecommendations) {
            window.CartDrawerRecommendations.cleanupOldEntries();
        }
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender () {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-count-bubble',
                section: 'header',
                selector: '.cart-count-bubble',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);
